export const environment = {
  production: false,
  envName: 'dev',
  firebaseConfig: {
    apiKey: 'AIzaSyDwMlduhLxBPDtDtD08OZ2T91vVgRde1Cs',
    authDomain: 'marcadores247-6d507.firebaseapp.com',
    projectId: 'marcadores247-6d507',
    storageBucket: 'marcadores247-6d507.appspot.com',
    messagingSenderId: '79835366104',
    appId: '1:79835366104:web:f651756e47990ad8b38dad',
    measurementId: 'G-SGVKMP0DDE',
    vapidKey: 'Dstfe2bc3jBpUIungHrhjJQVqCVIiaSTB3Ss4zwMhr8',
  },
  API: 'https://api.dev.marcadores247.com/api/',
  baseUrl: 'https://web.dev.marcadores247.com/',
  urlAssets: './assets/',
  urlIMG: './assets/img/',
  urlSVG: './assets/svg/',
  urlPNG: './assets/png/',
  urlIcon: './assets/img/icons/',
  urlSport: './assets/img/sports/',
  urlAudio: './assets/audios/',
  urlApp: 'https://web.dev.marcadores247.com/',
  urlWidgets: 'https://widgets.thesports01.com/',

  // torito keys
  // toritoApiURl: 'https://api.nexlot.pe/marc/nexlot/v1/',
  // toritoApiKey: 'c29lcP6DHN7hyxDqSnWBo4ypa82yKiGH6lrN6F1u',
  // toritoTokenAuthorization: 'Basic bWFyY2Fkb3Jlc2FmZjowRWw5QjBvWXZDejNpMGQ4',
  toritoApiURl: 'https://dev.nexlot.pe/marcuat/nexlot/v1/',
  toritoApiKey: 'Cj184YyABF2u8U7No3OKH6dPoScWLdcV6f0YdsQu',
  toritoTokenAuthorization: 'Basic bWFyY2Fkb3Jlc2FmZjptYXJjYWRvcmVzMTIzNA==',

  baseUrlWeb: 'https://core-api.dev.marcadores247.com',

  // wssocket
  wsMatchtUrl: 'wss://websockets-dev.marcadores247.com',

  // proto
  protoMatchtUrl: './assets/proto/client_events.proto',
};
